export const iconFontAwesomeGamingCriticalRole = (
	<i className="fa-solid fa-critical-role"></i>
);
